import { DateTime, Interval } from 'luxon';
const ensureDateTime = (date) => {
    if (date instanceof DateTime) {
        return date;
    }
    else if (date instanceof Date) {
        return getDateTimeFromDate(date);
    }
    else {
        return DateTime.now();
    }
};
const getDateTimeFromDate = (date) => DateTime.fromJSDate(date);
const sort = (date1, date2, reverse = false) => {
    const dateTime1 = getDateTimeFromDate(date1);
    const dateTime2 = getDateTimeFromDate(date2);
    if (dateTime1 < dateTime2) {
        return reverse ? 1 : -1;
    }
    if (dateTime1 === dateTime2) {
        return 0;
    }
    return reverse ? -1 : 1;
};
const isSameDay = (date1, date2) => date1.day === date2.day &&
    date1.month === date2.month &&
    date1.year === date2.year;
const getDuration = (startDate, endDate) => {
    const start = getDateTimeFromDate(startDate);
    const end = getDateTimeFromDate(endDate);
    const duration = Interval.fromDateTimes(start, end).toDuration([
        'hours',
        'minutes',
    ]);
    return `${duration.hours ? `${duration.hours}h ` : ''}${duration.minutes ? `${duration.minutes}min` : ''}`;
};
const getTime = (jsDate) => {
    const date = getDateTimeFromDate(jsDate);
    return date.toFormat('T');
};
const days = (interval) => {
    let cursor = ensureDateTime(interval.start).startOf('day');
    const days = [];
    while (cursor < ensureDateTime(interval.end)) {
        days.push(cursor);
        cursor = cursor.plus({ days: 1 });
    }
    return days;
};
const isBetween = (startDate, endDate, currentDate) => {
    const startDateTime = getDateTimeFromDate(startDate);
    const endDateTime = getDateTimeFromDate(endDate);
    const currentDateTime = getDateTimeFromDate(currentDate);
    return currentDateTime >= startDateTime && currentDateTime < endDateTime;
};
const getAllDatesBetweenTwoDates = ({ start, end, }) => {
    const startDate = ensureDateTime(start);
    const endDate = ensureDateTime(end);
    if (startDate.equals(endDate)) {
        return [startDate];
    }
    const interval = startDate.until(endDate);
    if (!interval.isValid) {
        return [];
    }
    return Array.from(days(interval));
};
const toISOString = (jsDate, opts = {}) => {
    const date = getDateTimeFromDate(jsDate);
    return date.toISO(opts) || '';
};
const isCurrentDay = (jsDate) => {
    const date = getDateTimeFromDate(jsDate);
    const today = DateTime.now();
    return (date.day === today.day &&
        date.month === today.month &&
        date.year === today.year);
};
const isTomorrow = (jsDate) => {
    const date = getDateTimeFromDate(jsDate);
    const tomorrow = DateTime.now().plus({ days: 1 });
    return (date.day === tomorrow.day &&
        date.month === tomorrow.month &&
        date.year === tomorrow.year);
};
const hourToDate = (hour) => {
    const [hours, minutes] = hour.split(':');
    return DateTime.now()
        .set({
        hour: parseInt(hours),
        minute: parseInt(minutes),
        second: 0,
        millisecond: 0,
    })
        .toJSDate();
};
function getLocalDatetime(date) {
    const now = date !== null && date !== void 0 ? date : new Date();
    // Récupérer les composants de la date
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Mois commence à 0, donc on ajoute 1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    // Construire le format attendu (YYYY-MM-DDTHH:mm)
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
export const DateHelpers = {
    getDateTimeFromDate,
    getAllDatesBetweenTwoDates,
    isSameDay,
    toISOString,
    getDuration,
    getTime,
    sort,
    isBetween,
    isCurrentDay,
    isTomorrow,
    hourToDate,
    getLocalDatetime,
};
//# sourceMappingURL=dateHelpers.js.map